// @ts-nocheck
import React, { useContext } from 'react';
import classNames from 'classnames';
import TabContext from '../TabContext';
import styles from '../style.module.css';

function Panel(props : any) {
  const {
    children,
    name,
    index,
    className,
  } = props;

  const { activeTab, idPrefix, assignRefToPanel } : any = useContext(TabContext);

  return (
    <props.component
      ref={assignRefToPanel}
      className={classNames(
        styles.tabPanel,
        className,
        {
          [styles.tabPanelHidden]: activeTab !== index,
        },
      )}
      id={name}
      role="tabpanel"
      tabIndex="-1"
      aria-labelledby={`${idPrefix}-tab-${index}`}
    >
      {children}
    </props.component>
  );
}

Panel.defaultProps = {
  className: null,
  component: 'section',
};


export default Panel;
